import axios from "axios";
import $utils from '@/assets/js/utils'
import qs from "qs";
import VueCookie from 'vue-cookie'
import {
	encryptByDES,
	decryptByDES
} from '@/assets/js/3DES.js';
import {
	windowOpen,
	toUrl,
	goUrls
} from "@/assets/js/common.js";
import vm from '../main'
import {
	Message
} from 'element-ui';

// 处理401token过期
// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []


//定义一个新的Message方法
let messageInstance = null;
const $message = options => {
	if (messageInstance) {
		//判断是否有提示框，有则关闭
		messageInstance.close();
	}
	messageInstance = Message(options);
	return messageInstance;
};

//重写方法
['success', 'warning', 'info', 'error'].forEach(type => {
	$message[type] = options => {
		if (typeof options === 'string') {
			options = {
				message: options,
				offset: 80
			};
		}
		options.type = type;
		return Message(options);
	};
});

let is_loading = false;
let othen_headers = {};
let baseURL;
let wwwurl = window.location.hostname;

const instance = axios.create({
	//   baseURL, //如果配置了环境变量就可以直接写/api,
	timeout: 15000, //请求超时
	headers: {
		// 设置后端需要的传参类型
		'Content-Type': 'application/json',
		'X-Requested-With': 'XMLHttpRequest',
		'PassPort': 1,
		'SystemPaaS': 14,
	},
});
// 给实例添加一个setToken方法，用于登录后将最新token动态添加到header，同时将token保存在localStorage中
const setToken = (token, expiration) => {
	instance.defaults.headers['Authorization'] = "Bearer " + token
	let expiration_time = VueCookie.get("loginTime")
	let expiresNum = 1
	if (expiration_time) {
		expiresNum = 30
	}
	VueCookie.set('token', token, {
		expires: expiresNum,
	})
}
// 设置请求拦截
instance.interceptors.request.use(
	(config) => {
		//loading
		let token = VueCookie.get("token");
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
			config.headers["token"] = token;
		}
		if (Object.keys(othen_headers).length) {
			config.headers = {
				...config.headers,
				...othen_headers
			}
		}
		//最后的话一定要给他return出去 不return不执行
		return config;
	},
	(err) => {
		//请求的时候如果发生错误了， 这边直接给它抛出错误就行
		throw new Error(err);
	}
);

// 设置响应拦截
instance.interceptors.response.use(
	(response) => {
		//判断状态码
		const res = response.data;
		if (res.succ || res.status || res.statusCode == 200) {
			return res;
		} else {
			// 登录超时,重新登录
			if (res.code == 10003) {
				$message.error(err.msg)
			} else if (res.StatusCode == 500) {
				$message.error(res.message)
			} else if (res.StatusCode == 401) {
				if (VueCookie.get("token")) {
					getRefreshToken(response)
				} else {
					toUrl("loginPage")
				}
			} else if (res.StatusCode == 403) {
				//权限控制（vip与非vip）
			}
			return Promise.reject(res || "error");
		}
	},
	(err) => {
		if (err) {
			let {
				data: res
			} = err.response
			if (res.StatusCode == 401) {
				if (res.Message) {
					res['message'] = res.Message
				}
				if (VueCookie.get("token")) {
					getRefreshToken(err)
				} else {
					toUrl("loginPage")
				}
			} else if (res.StatusCode == 403) {} else {
				return Promise.reject(err);
			}
		} else {
			return Promise.reject(err);
		}

	}
);

const request = (option) => {
	let {
		url = "",
			data = {},
			method = "get",
			loading = false,
			api = "",
			jm = "",
			headers = {},

	} = option;
	othen_headers = headers;
	// 这个是必须配置线上环境的请求，测试环境不能用
	let prodApi = ['Page/Info', 'Dictionary/Code?', 'Page/Type']
	if (api == "passport") {
		baseURL = 'https://passport.eiceducation.com.cn/api/v1/';
		// baseURL = 'https://passport-test.eiceducation.com.cn/api/v1/';

	} else if (api == "plan") {
		baseURL = 'https://gk-api.eiceducation.com.cn/api/v1/';
		// baseURL = 'https://gk-api-test.eiceducation.com.cn/api/v1/';
		if (prodApi.includes(url)) {
			baseURL = 'https://gk-api.eiceducation.com.cn/api/v1/';
			// baseURL = 'https://gk-api-test.eiceducation.com.cn/api/v1/';
		}
	}
	instance.defaults.baseURL = baseURL;
	is_loading = loading;
	method = method.toLowerCase();
	let r_body;
	switch (method) {
		case "get":
		case "delete":
			r_body = {
				params: data,
			};
			break;
		case "post":
		case "put":
			r_body = data;
			break;
	}
	return new Promise((resolve, reject) => {
		instance[method](url, r_body)
			.then((res) => {
				if (jm == "3DES") {
					let ResData = decryptByDES(res.data)
					res.data = ResData
				}
				deepChangeField(res.data)
				resolve(res);
			})
			.catch((err) => {
				// alert(err.message)
				// if (err.code == "ERR_BAD_REQUEST" || err.code == "ERR_NETWORK") {
				// 	toUrl("loginPage")
				// 	return;
				// }
				reject(err);
			});
	});
};
const deepChangeField = (data, fl = 'majorGroupCode') => {
	if (Object.prototype.toString.call(data) === '[object Object]') {
		for (let k in data) {
			if (data[fl]) {
				var pattern = new RegExp("[\[\]{}【】]", 'g')
				data[fl] = data[fl].replace(pattern, '')
			}
			if (Object.prototype.toString.call(data[k]) === '[object Object]' || Object.prototype.toString.call(
					data[k]) === '[object Array]') {
				deepChangeField(data[k], fl)
			}
		}
	}
	if (Object.prototype.toString.call(data) === '[object Array]') {
		data = data.filter(item => item !== null);
		for (let item of data) {
			if (item[fl]) {
				var pattern = new RegExp("[\\[\\]{}【】]", 'g')
				item[fl] = item[fl].replace(pattern, '')
			}
			if (Object.prototype.toString.call(item) === '[object Object]' || Object.prototype.toString.call(
					item) === '[object Array]') {
				deepChangeField(item, fl)
			}
		}
	}
}
const getRefreshToken = (response) => {
	const config = response.config
	if (!isRefreshing) {
		isRefreshing = true
		let loginInfo = VueCookie.get('loginInfo') ? JSON.parse(VueCookie.get('loginInfo')) : {}
		request({
			api: "plan",
			url: "Login/RefreshToken",
			method: 'post',
			headers: {
				RefreshToken: loginInfo.refresh_token
			}
		}).then(res => {
			let {
				access_token: token,
				expiration
			} = res.data
			setToken(token, expiration)
			let expiration_time = VueCookie.get("loginTime")
			let expiresNum = 1
			if (expiration_time) {
				expiresNum = 30
			}
			$utils.setLoginExpiration(res.data, expiresNum)
			//获取失败请求
			//重置失败请求的配置
			config.headers["Authorization"] = "Bearer " + token;
			//已经刷新了token，将所有队列中的请求进行重试
			requests.forEach(cb => cb(token))
			// 重试完了别忘了清空这个队列
			requests = []
			//重试当前请求并返回promise
			return instance(config)
		}).catch(err => {
			VueCookie.delete("token");
			VueCookie.delete("userInfo");
			VueCookie.delete("loginInfo");
			VueCookie.delete("checked");
			sessionStorage.removeItem("getBusinessProvince")
			toUrl("loginPage")
		}).finally(() => {
			//完成之后在关闭状态
			isRefreshing = false
		})
	} else {
		// 正在刷新token，返回一个未执行resolve的promise
		return new Promise((resolve) => {
			// 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
			requests.push((token) => {
				config.headers["Authorization"] = "Bearer " + token;
				resolve(instance(config))
			})
		})
	}

}
//导出  导出这个模块
export default request;
